module.exports = __webpack_public_path__ + "img/emoji_86.2dd17f01.png";